import { c as _c } from "react/compiler-runtime";
import ProstackLogoIcon from "../icons/prostack-logo-icon";
import { Button } from "../ui/button";
import Link from "@/components/atoms/link";
import LoadingThreeDots from "../atoms/loading-three-dots";
import { LINK_SUPPORT_DOCUMENTATION_SUPPORT } from "@/lib/links";
import { LogIn } from "lucide-react";
export default function Login(t0) {
  const $ = _c(14);
  const {
    errorText,
    loading,
    handleLogin
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex items-center justify-center"><ProstackLogoIcon /></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="text-center"><h1 className="text-3xl font-bold">Welcome back!</h1><p className="text-muted-foreground">Sign in to manage your hosting account.</p></div>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== errorText) {
    t3 = errorText && <div className="rounded-md bg-red-100 p-4 text-red-900"><p>Unable to login: {errorText}</p></div>;
    $[2] = errorText;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== loading) {
    t4 = loading ? <>Signing in <LoadingThreeDots variant="outline" /></> : <><LogIn className="h-6 w-6" />Sign in via the portal</>;
    $[4] = loading;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== handleLogin || $[7] !== loading || $[8] !== t4) {
    t5 = <Button disabled={loading} className="w-full justify-center gap-2" onClick={handleLogin} variant="outline">{t4}</Button>;
    $[6] = handleLogin;
    $[7] = loading;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <p className="text-center text-muted-foreground">{"If you're having trouble logging in, please "}<Link href={LINK_SUPPORT_DOCUMENTATION_SUPPORT}>contact support</Link>.</p>;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t3 || $[12] !== t5) {
    t7 = <div className="flex h-screen w-full items-center justify-center bg-background"><div className="mx-4 w-full max-w-md space-y-6">{t1}{t2}{t3}{t5}{t6}</div></div>;
    $[11] = t3;
    $[12] = t5;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
}